import React, { Component, MouseEvent } from 'react';
import classes from './Popup.module.scss';
import Button from '../Button/Button';
import {ViewContext} from "../../../context/ViewContext";

interface IProps {
    show: boolean;
    // lastAdded: { title: string; id: number };
    message?: string;
    buttonText?: string;
    buttonClicked?: (event: MouseEvent) => void;
}

interface IState {
    viewPortHeight: number;
}

function getViewportHeight(): number {
    try {
        return window.visualViewport.height
    } catch (e) {
        return 0
    }
}

class Popup extends Component<IProps> {
    state: IState = {
        viewPortHeight: getViewportHeight()
    }

    shouldComponentUpdate(nextProps: IProps) {
        return nextProps.show !== this.props.show || (this.props.show && nextProps !== this.props);
    }

    componentDidMount() {
        try {
            window.visualViewport.addEventListener('resize', this.viewportResize)
        } catch(e) {}
    }

    componentWillUnmount() {
        try {
            window.visualViewport.removeEventListener('resize', this.viewportResize)
        } catch(e) {}
    }

    viewportResize = () => {
        this.setState({
            viewPortHeight: getViewportHeight()
            }
        )
    }

    updateViewport = () => {
        // Warum auch immer hängt das Popup bei Vivaldi in der Luft, wenn man einen Eintrag
        // aus der Autovervollständigung hinzufügt und die Option "Sofort abhaken" ausgewählt ist.
        // Daher forceUpdate und viewportResize überprüfen.
        this.viewportResize()
        this.forceUpdate()
    }


    render() {
        if (!this.props.show) {return null;}
        let popupClasses = [classes.popup, this.props.show ? classes.show : null]
            .filter(Boolean)
            .join(' ');
        const isKeyboardOpen = window.innerHeight - 50 > this.state.viewPortHeight
        let position = {bottom: "6rem"}
        if (getViewportHeight() && isKeyboardOpen) {
            // @ts-ignore
            position = {top: `calc(${this.state.viewPortHeight}px - 5.5rem)`}
            setTimeout(this.updateViewport, 250)
        }
        return (
            <div className={classes.popupBackground}>
                <div className={popupClasses} style={position}>
                    {this.props.message ? <p>{this.props.message}</p> : null}

                    {this.props.buttonClicked ? (
                        <Button buttonType="Primary" clicked={this.props.buttonClicked}>
                            {this.props.buttonText}
                        </Button>
                    ) : null}
                </div>
            </div>
        );
    }
}

export class MainPopup extends Component {
    static contextType = ViewContext;
    context!: React.ContextType<typeof ViewContext>;

    render() {
        return <Popup show={this.context.state.popupShown}
                      message={this.context.state.popupMessage}
                      buttonText={this.context.state.popupAction}
                      buttonClicked={this.context.state.popupCallback}
                      />
    }
}

export default Popup;
